// extracted by mini-css-extract-plugin
export default {"header":"Mobile_HeaderComponent_header__If-JZ","row":"Mobile_HeaderComponent_row__gC5H6","btn":"Mobile_HeaderComponent_btn__oB3h5"};